// extracted by mini-css-extract-plugin
export var container = "_md-0";
export var dotAnimation = "_md-2";
export var dotsLoading = "_md-1";